import {
  DataTable,
  DataTableProps,
} from "../../../components/common/data-table/DataTable";
import Loading from "../../../components/Loading";
import { ColumnInterface } from "../../../interfaces/customTableInterface";
import { ProductInterface } from "../../../interfaces/productInterface";
import formatToMoney from "../../../utils/formatToMoney";

type ProductTableProps = {
  data: ProductInterface[];
  isLoading: boolean;
  categoryNameById: Record<string, string>;
} & Pick<
  DataTableProps<ProductInterface>,
  "pagination" | "extraActions" | "sortBy" | "sortOrder" | "onSort"
>;

const columns: ColumnInterface<ProductInterface>[] = [
  { key: "name", label: "Nombre" },
  { key: "categoryId", label: "Categoría" },
  { key: "price", label: "Precio" },
  { key: "active", label: "Activo", isBoolean: true },
];

export const ProductTable = (props: ProductTableProps) => {
  const { isLoading, categoryNameById, ...rest } = props;

  if (isLoading) return <Loading />;

  return (
    <DataTable
      columns={columns}
      tableId="product-table"
      customRender={(key, item) => {
        if (key === "price") {
          return formatToMoney(item.price);
        }
        if (key === "categoryId") {
          return categoryNameById[item.categoryId] ?? item.categoryId;
        }
        if (key === "active") {
          return item.active ? "Activo" : "Inactivo";
        }
        return item[key] ?? "N/A";
      }}
      {...rest}
    />
  );
};
